














































import Vue from "vue";
import CancelButton from "@/components/Button/CancelButton.vue";
import ValidateButton from "@/components/Button/ValidateButton.vue";
export default Vue.extend({
  name: "Modal",
  components: {
    CancelButton,
    ValidateButton
  },
  props: {
    display: {
      type: Boolean,
      default: false
    },
    onClose: {
      type: Function,
      default: () => undefined
    },
    onValidate: {
      type: Function,
      default: () => undefined
    },
    title: {
      type: String,
      default: "Modal title"
    },
    BackgroundColor: {
      type: String,
      default: "var(--main-color)"
    },
    width: {
      type: Number,
      default: 1000
    },
    height: {
      type: Number,
      default: 1000
    },
    BorderRadius: {
      type: String,
      default: "6px"
    },
    // Button
    buttonPosition: {
      type: String,
      default: "flex-start"
    },
    buttonYes: {
      type: Object,
      default: () => ({
        display: true,
        content: "Créer",
        loading: false
      })
    },
    buttonNo: {
      type: Object,
      default: () => ({
        display: true,
        content: "Annuler",
        loading: false,
        callback: undefined
      })
    }
  },
  computed: {
    style() {
      return {
        borderRadius: this.BorderRadius,
        backgroundColor: this.BackgroundColor
      };
    },
    styleButton() {
      return {
        justifyContent: this.buttonPosition
      };
    }
  }
});
